<template>
  <div class="c-container">
    <header class="c-header">
      <img
        height="40px"
        src="/img/logo_treed_v1.svg"
        alt="logo"
        @click="mainPage"
      />
    </header>
    <div>
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginLayout",
  methods: {
    mainPage() {
      const urlPath = this.$route.path;

      if (urlPath === "/login") {
        return;
      }

      this.$router.push("/login");
    },
  },
};
</script>

<style>
.c-container {
  justify-content: center;
  align-items: center;
  min-height: 100svh;
  display: flex;
}

.c-header {
  display: flex;
  align-items: center;
  width: 150px;
  height: 110px;
  top: 0;
  position: absolute;
  cursor: pointer;
  left: 30svw;
}

@media (max-width: 1100px) {
  .c-header {
    width: 100%;
  }
}
</style>
